import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Fusionne des classes Tailwind en resolvant les conflits : la derniere
 * gagne. Sans twMerge, `cn("p-4", "p-8")` produirait les deux et le resultat
 * dependrait de l ordre dans la feuille de style.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const eurFormatter = new Intl.NumberFormat("fr-BE", {
  style: "currency",
  currency: "EUR",
});

/** Les montants circulent en centimes ; on ne divise qu ici, a l affichage. */
export function formatPrice(cents: number): string {
  return eurFormatter.format(cents / 100);
}

const dateFormatter = new Intl.DateTimeFormat("fr-BE", { dateStyle: "medium" });

export function formatDate(value: string | Date): string {
  return dateFormatter.format(typeof value === "string" ? new Date(value) : value);
}

export function formatDateRange(start: string | Date, end: string | Date): string {
  return `du ${formatDate(start)} au ${formatDate(end)}`;
}

/** Date du jour au format attendu par un <input type="date">. */
export function toDateInputValue(date: Date): string {
  return date.toISOString().slice(0, 10);
}
